module.exports = __webpack_public_path__ + "c721ee2efd85ab93c97998429d8365bd.pdf";